import _ from 'lodash';
import { StrategyGoalsDB } from './types';

export const getActiveStrategyGoalsInPriorityOrder = (strategyGoals: StrategyGoalsDB) => _.sortBy(_.filter(strategyGoals, { active: true }), 'priority');
